import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import 'webix/photo'; // Importing photo module from webix
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the upload image view.
 * @extends JetView
 */
export default class uploadImageView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Right section of the layout containing the form for image upload
        const right = {
            position: 'center',
            modal: true,
            id: 'ImageAdd',
            body: {
                view: 'form',
                id: 'addImage',
                elements: [
                    {
                        view: 'my_uploader', // Custom uploader component
                        value: _('Subir Imagen'), // Button label for upload
                        name: 'upload',
                        id: 'upload',
                        autosend: false, // Prevents automatic sending of files
                        link: 'mylist', // Link to the list component
                        upload: devConfig.geturlApi() + 'Image/uploadImage', // API endpoint for uploading images
                        multiple: false, // Allows only single file upload
                    },
                    {
                        view: 'list', // List component to display uploaded files
                        id: 'mylist',
                        type: 'uploader',
                        autoheight: true,
                        borderless: true,
                    },
                    {
                        view: 'button', // Button to obtain the URL of the uploaded image
                        type: 'form',
                        value: _('Obtener URL'), // Button label
                        click: function ($e) {
                            // Click event handler for the button
                            if (
                                Object.keys($$('upload').files.data.pull).length > 0 // Checks if there are files to upload
                            ) {
                                $$('upload').send(function (response) {
                                    // Sends the file and handles the response
                                    var myForm = webix.modalbox({
                                        title: 'URL', // Title of the modal box
                                        width: 'auto',
                                        text: response.url, // Displays the URL of the uploaded image
                                        buttons: [_('Cerrar')], // Close button
                                    });
                                });
                            }
                        },
                    },
                ],
            },
        };

        // Left section of the layout containing the toolbar
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Applies the current theme
                    elements: [
                        { view: 'label', label: _('Subir Imagen') }, // Label for the toolbar
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon', // Icon button to close the view
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigates to the dashboard on click
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        webix.ui.fullScreen(); // Sets the UI to full screen mode

        // Custom uploader component definition
        webix.protoUI(
            {
                name: 'my_uploader', // Name of the custom uploader
                $init: function (config) {}, // Initialization function
            },
            webix.EventSystem, // Inherits from EventSystem
            webix.ui.uploader, // Extends the uploader component
        );

        // Returns the main layout configuration
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    rows: [left, right], // Combines left and right sections
                    columns: [],
                },
            ],
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid object (not used in this fragment).
     */
    init(grid) {}
}

// FILE DOCUMENTED
